function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21.19,
    height: 10.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8116666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 5.435,
    fontFamily: "Arial"
  }, "\n        Norton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.87,
    width: 21.19,
    height: 10.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.37375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 16.365,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.86,
    width: 21.19,
    height: 16.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.292857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 29.884999999999998,
    fontFamily: "Arial"
  }, "\n        Emporia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 37.91,
    width: 21.19,
    height: 16.5,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 46.16,
    fontFamily: "Arial"
  }, "\n        Bath\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 54.41,
    width: 21.19,
    height: 16.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8477777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 62.724999999999994,
    fontFamily: "Arial"
  }, "\n        Covington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 71.04,
    width: 21.19,
    height: 16.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.376
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 79.48,
    fontFamily: "Arial"
  }, "\n        Galax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 87.92,
    width: 21.19,
    height: 16.98,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 96.41,
    fontFamily: "Arial"
  }, "\n        Lexington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 104.9,
    width: 21.19,
    height: 17.27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 113.53500000000001,
    fontFamily: "Arial"
  }, "\n        Buena_Vista\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.17,
    width: 21.19,
    height: 18.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6242857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 131.355,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 140.54,
    width: 21.19,
    height: 18.95,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.79
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 150.015,
    fontFamily: "Arial"
  }, "\n        Craig\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 159.49,
    width: 21.19,
    height: 20.71,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 169.845,
    fontFamily: "Arial"
  }, "\n        Bland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180.2,
    width: 21.19,
    height: 23.75,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5135714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 192.075,
    fontFamily: "Arial"
  }, "\n        King_and_Queen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 203.95,
    width: 21.19,
    height: 24.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6300000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 215.98999999999998,
    fontFamily: "Arial"
  }, "\n        Manassas_Park\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 228.03,
    width: 21.19,
    height: 24.29,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 240.175,
    fontFamily: "Arial"
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 252.33,
    width: 21.19,
    height: 24.86,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 264.76,
    fontFamily: "Arial"
  }, "\n        Charles_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 277.19,
    width: 21.19,
    height: 25.46,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.238
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 289.92,
    fontFamily: "Arial"
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 302.64,
    width: 21.19,
    height: 25.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 315.41999999999996,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 328.2,
    width: 21.19,
    height: 29.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 342.835,
    fontFamily: "Arial"
  }, "\n        Rappahannock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 357.48,
    width: 21.19,
    height: 29.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.119
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 372.39000000000004,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 387.3,
    width: 21.19,
    height: 30.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9263636363636365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 402.69,
    fontFamily: "Arial"
  }, "\n        Greensville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 418.08,
    width: 21.19,
    height: 31.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 433.695,
    fontFamily: "Arial"
  }, "\n        Williamsburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 449.31,
    width: 21.19,
    height: 31.4,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.238
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 465.01,
    fontFamily: "Arial"
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 480.71,
    width: 21.19,
    height: 31.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5316666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 496.41499999999996,
    fontFamily: "Arial"
  }, "\n        Sussex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 512.11,
    width: 21.19,
    height: 35.02,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.027142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 529.62,
    fontFamily: "Arial"
  }, "\n        Radford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 547.13,
    width: 21.19,
    height: 37.07,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.027142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 565.665,
    fontFamily: "Arial"
  }, "\n        Mathews\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 584.21,
    width: 21.19,
    height: 37.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.354444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 603.1650000000001,
    fontFamily: "Arial"
  }, "\n        Lunenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.12,
    width: 21.19,
    height: 38.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.354444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 641.555,
    fontFamily: "Arial"
  }, "\n        Middlesex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 660.99,
    width: 21.19,
    height: 39.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5316666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.595,
    y: 680.495,
    fontFamily: "Arial"
  }, "\n        Amelia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 0,
    width: 27.29,
    height: 30.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.032222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.835,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.49,
    y: 0,
    width: 27.6,
    height: 30.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5090909090909093
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.290000000000006,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.08,
    y: 0,
    width: 28.12,
    height: 30.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.14,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Martinsville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.2,
    y: 0,
    width: 28.97,
    height: 30.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.138571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.685,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.17,
    y: 0,
    width: 30.25,
    height: 30.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.295,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Buckingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.41,
    y: 0,
    width: 30.26,
    height: 30.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.54,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Nottoway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.68,
    y: 0,
    width: 30.6,
    height: 30.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.544166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.98000000000002,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Falls_Church\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.28,
    y: 0,
    width: 31.27,
    height: 30.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3922222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.915,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.54,
    y: 0,
    width: 32.16,
    height: 30.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1807142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.62,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.71,
    y: 0,
    width: 32.52,
    height: 30.53,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.81625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.96999999999997,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Poquoson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.23,
    y: 0,
    width: 32.65,
    height: 30.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.088333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.555,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.87,
    y: 0,
    width: 33.4,
    height: 30.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.053
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 369.57,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Appomattox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.27,
    y: 0,
    width: 33.74,
    height: 30.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.361428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.14,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Bristol\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.02,
    y: 0,
    width: 33.79,
    height: 30.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.106
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 436.91499999999996,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.81,
    y: 0,
    width: 34.37,
    height: 30.53,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.544166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.995,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488.18,
    y: 0,
    width: 34.49,
    height: 30.53,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.544166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.425,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        King_William\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.67,
    y: 0,
    width: 34.76,
    height: 30.53,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3922222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.05,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 557.42,
    y: 0,
    width: 34.82,
    height: 30.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.088333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 574.8299999999999,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.25,
    y: 0,
    width: 35.82,
    height: 30.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.361428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.16,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Grayson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 628.06,
    y: 0,
    width: 35.83,
    height: 30.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.088333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 645.9749999999999,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Nelson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 663.89,
    y: 0,
    width: 36.11,
    height: 30.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3922222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 681.9449999999999,
    y: 15.265,
    fontFamily: "Arial"
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 30.53,
    width: 37.24,
    height: 30.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3153846153846156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 45.58,
    fontFamily: "Arial"
  }, "\n        Prince_Edward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 60.62,
    width: 37.24,
    height: 30.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3855555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 75.85499999999999,
    fontFamily: "Arial"
  }, "\n        Dickenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 91.09,
    width: 37.24,
    height: 30.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8018181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 106.5,
    fontFamily: "Arial"
  }, "\n        Southampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 121.91,
    width: 37.24,
    height: 30.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.168
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 137.32999999999998,
    fontFamily: "Arial"
  }, "\n        Giles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 152.75,
    width: 37.24,
    height: 31.03,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2164285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 168.265,
    fontFamily: "Arial"
  }, "\n        Fredericksburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 183.78,
    width: 37.24,
    height: 32.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9618181818181815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 200.07,
    fontFamily: "Arial"
  }, "\n        King_George\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 216.36,
    width: 37.24,
    height: 32.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.08125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 232.685,
    fontFamily: "Arial"
  }, "\n        Hopewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 249.01,
    width: 37.24,
    height: 32.69,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.08625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 265.355,
    fontFamily: "Arial"
  }, "\n        New_Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 281.7,
    width: 37.24,
    height: 32.76,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.276
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 298.08,
    fontFamily: "Arial"
  }, "\n        Waynesboro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 314.46,
    width: 37.24,
    height: 33.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.827142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 331.35499999999996,
    fontFamily: "Arial"
  }, "\n        Patrick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 348.25,
    width: 37.24,
    height: 33.86,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.11625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 365.18,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 382.11,
    width: 37.24,
    height: 37.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.724
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 400.995,
    fontFamily: "Arial"
  }, "\n        Rockbridge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 419.88,
    width: 37.24,
    height: 38.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.724
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 439.09499999999997,
    fontFamily: "Arial"
  }, "\n        Winchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 458.31,
    width: 37.24,
    height: 39.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 478.06,
    fontFamily: "Arial"
  }, "\n        Page\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 497.82,
    width: 37.24,
    height: 39.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 517.625,
    fontFamily: "Arial"
  }, "\n        Staunton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 537.43,
    width: 37.24,
    height: 40.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.413333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 557.525,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 577.62,
    width: 37.24,
    height: 40.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 597.835,
    fontFamily: "Arial"
  }, "\n        Buchanan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 618.05,
    width: 37.24,
    height: 40.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 638.525,
    fontFamily: "Arial"
  }, "\n        Caroline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.19,
    y: 659,
    width: 37.24,
    height: 41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.448
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.81,
    y: 679.5,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 30.53,
    width: 38.07,
    height: 41.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 77.475,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Goochland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 30.53,
    width: 38.83,
    height: 41.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.547142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.91499999999999,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Fairfax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.33,
    y: 30.53,
    width: 39.91,
    height: 41.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.434444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.28500000000003,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Dinwiddie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.24,
    y: 30.53,
    width: 40.34,
    height: 41.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 195.41000000000003,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Fluvanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 215.59,
    y: 30.53,
    width: 40.61,
    height: 41.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3841666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 235.895,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Harrisonburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256.2,
    y: 30.53,
    width: 42.06,
    height: 41.61,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.944285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.23,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Russell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.26,
    y: 30.53,
    width: 42.28,
    height: 41.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.4,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Salem\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.55,
    y: 30.53,
    width: 42.54,
    height: 41.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.82,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Wythe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.09,
    y: 30.53,
    width: 44,
    height: 41.61,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.161
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.09,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Petersburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.09,
    y: 30.53,
    width: 44.31,
    height: 41.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.245,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Louisa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.4,
    y: 30.53,
    width: 44.66,
    height: 41.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.944285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.72999999999996,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.06,
    y: 30.53,
    width: 44.78,
    height: 41.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.20125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.4499999999999,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Powhatan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.84,
    y: 30.53,
    width: 45.36,
    height: 41.61,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.322
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.52,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Smyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 606.2,
    y: 30.53,
    width: 46.74,
    height: 41.61,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.944285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.57,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Amherst\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.94,
    y: 30.53,
    width: 47.06,
    height: 41.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7827272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.47,
    y: 51.335,
    fontFamily: "Arial"
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 72.14,
    width: 46.06,
    height: 42.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.36375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 93.595,
    fontFamily: "Arial"
  }, "\n        Manassas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 115.05,
    width: 46.06,
    height: 43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.166666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 136.55,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 158.05,
    width: 46.06,
    height: 44.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3907692307692305
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 180.09,
    fontFamily: "Arial"
  }, "\n        Prince_George\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 202.13,
    width: 46.06,
    height: 44.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 224.34,
    fontFamily: "Arial"
  }, "\n        Accomack\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 246.55,
    width: 46.06,
    height: 46.79,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.676666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 269.945,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 293.33,
    width: 46.06,
    height: 47.4,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 317.03,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 340.73,
    width: 46.06,
    height: 47.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 364.53000000000003,
    fontFamily: "Arial"
  }, "\n        Wise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 388.33,
    width: 46.06,
    height: 48.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 412.7,
    fontFamily: "Arial"
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 437.07,
    width: 46.06,
    height: 51.38,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.070666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 462.76,
    fontFamily: "Arial"
  }, "\n        Charlottesville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 488.46,
    width: 46.06,
    height: 51.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 514.41,
    fontFamily: "Arial"
  }, "\n        Culpeper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 540.36,
    width: 46.06,
    height: 52.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.117777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 566.63,
    fontFamily: "Arial"
  }, "\n        Botetourt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 592.89,
    width: 46.06,
    height: 52.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5430769230769235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 619.28,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.44,
    y: 645.68,
    width: 46.06,
    height: 54.32,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.606
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.47,
    y: 672.8399999999999,
    fontFamily: "Arial"
  }, "\n        Gloucester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 72.14,
    width: 44.93,
    height: 58.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.493
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.965,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Shenandoah\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.44,
    y: 72.14,
    width: 45.81,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.72625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.345,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.25,
    y: 72.14,
    width: 50.09,
    height: 58.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.26125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.29500000000002,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Danville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.33,
    y: 72.14,
    width: 58.24,
    height: 58.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.45,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.57,
    y: 72.14,
    width: 59,
    height: 58.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.07,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.58,
    y: 72.14,
    width: 60.27,
    height: 58.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.715,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.85,
    y: 72.14,
    width: 61.48,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.59000000000003,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.32,
    y: 72.14,
    width: 69.03,
    height: 58.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.495555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.835,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Lynchburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.35,
    y: 72.14,
    width: 71.85,
    height: 58.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.871666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.275,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Pittsylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.2,
    y: 72.14,
    width: 74.8,
    height: 58.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.495555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.6,
    y: 101.37,
    fontFamily: "Arial"
  }, "\n        Frederick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 130.59,
    width: 65.9,
    height: 67.93,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 164.555,
    fontFamily: "Arial"
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 198.52,
    width: 65.9,
    height: 69.06,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 233.05,
    fontFamily: "Arial"
  }, "\n        Augusta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 267.58,
    width: 65.9,
    height: 69.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 302.315,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 337.05,
    width: 65.9,
    height: 69.55,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 371.825,
    fontFamily: "Arial"
  }, "\n        Fauquier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 406.6,
    width: 65.9,
    height: 72.28,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 442.74,
    fontFamily: "Arial"
  }, "\n        James_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 478.88,
    width: 65.9,
    height: 73.01,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 515.385,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 551.89,
    width: 65.9,
    height: 73.27,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.590000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 588.525,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.5,
    y: 625.16,
    width: 65.9,
    height: 74.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 137.45,
    y: 662.5799999999999,
    fontFamily: "Arial"
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.4,
    y: 130.59,
    width: 73.99,
    height: 74.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.569999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 207.395,
    y: 167.86,
    fontFamily: "Arial"
  }, "\n        Roanoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.39,
    y: 130.59,
    width: 81.26,
    height: 74.54,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.454000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.02,
    y: 167.86,
    fontFamily: "Arial"
  }, "\n        Portsmouth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325.65,
    y: 130.59,
    width: 89.87,
    height: 74.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.282222222222224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.585,
    y: 167.86,
    fontFamily: "Arial"
  }, "\n        Albemarle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.52,
    y: 130.59,
    width: 93.41,
    height: 74.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.211666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.22499999999997,
    y: 167.86,
    fontFamily: "Arial"
  }, "\n        Spotsylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.93,
    y: 130.59,
    width: 94.52,
    height: 74.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.3175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 556.19,
    y: 167.86,
    fontFamily: "Arial"
  }, "\n        Stafford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.45,
    y: 130.59,
    width: 96.55,
    height: 74.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.64857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.725,
    y: 167.86,
    fontFamily: "Arial"
  }, "\n        Roanoke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.4,
    y: 205.13,
    width: 94.54,
    height: 80.39,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.484285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.67000000000002,
    y: 245.325,
    fontFamily: "Arial"
  }, "\n        Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.4,
    y: 285.52,
    width: 94.54,
    height: 90.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.904285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.67000000000002,
    y: 330.685,
    fontFamily: "Arial"
  }, "\n        Hampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.4,
    y: 375.85,
    width: 94.54,
    height: 99.68,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.67000000000002,
    y: 425.69000000000005,
    fontFamily: "Arial"
  }, "\n        Alexandria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.4,
    y: 475.53,
    width: 94.54,
    height: 110.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.878333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.67000000000002,
    y: 530.5849999999999,
    fontFamily: "Arial"
  }, "\n        Newport_News\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.4,
    y: 585.64,
    width: 94.54,
    height: 114.36,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.505714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.67000000000002,
    y: 642.8199999999999,
    fontFamily: "Arial"
  }, "\n        Norfolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.94,
    y: 205.13,
    width: 87.64,
    height: 129.92,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.76,
    y: 270.09,
    fontFamily: "Arial"
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.58,
    y: 205.13,
    width: 107.94,
    height: 129.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.794
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.54999999999995,
    y: 270.09,
    fontFamily: "Arial"
  }, "\n        Chesapeake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 460.53,
    y: 205.13,
    width: 111.61,
    height: 129.92,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.401111111111112
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 516.3349999999999,
    y: 270.09,
    fontFamily: "Arial"
  }, "\n        Arlington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.14,
    y: 205.13,
    width: 127.86,
    height: 129.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.265714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.0699999999999,
    y: 270.09,
    fontFamily: "Arial"
  }, "\n        Loudoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.94,
    y: 335.05,
    width: 167.62,
    height: 120.7,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.621428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.75,
    y: 395.40000000000003,
    fontFamily: "Arial"
  }, "\n        Prince_William\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.94,
    y: 455.76,
    width: 167.62,
    height: 121.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.419999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.75,
    y: 516.73,
    fontFamily: "Arial"
  }, "\n        Henrico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.94,
    y: 577.7,
    width: 167.62,
    height: 122.3,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.191666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.75,
    y: 638.85,
    fontFamily: "Arial"
  }, "\n        Chesterfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.56,
    y: 335.05,
    width: 267.44,
    height: 100.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.188571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.28,
    y: 385.37,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.56,
    y: 435.7,
    width: 267.44,
    height: 264.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 37.75714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.28,
    y: 567.85,
    fontFamily: "Arial"
  }, "\n        Fairfax\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.91b375d2fbabf6f90ee6ee06edec49ce.svg";
export { ForwardRef as ReactComponent };